module.exports = __webpack_public_path__ + "static/media/ELIMINAR.cd13a217.png";